export const table = [
  {
    tdesc: 'Urgent Safety Recall',
    tdue: '06/04/2022',
    toverdue: '08/04/2022',
    tnotify: 'David Demo',
    tstatus: 'Completed'
  },

  {
    tdesc: 'Urgent Safety Recall',
    tdue: '06/04/2022',
    toverdue: '08/04/2022',
    tnotify: 'David Demo',
    tstatus: 'Completed'
  },
]
